import { PbError } from '@owner/errors'

class UnauthorizedError extends PbError {
  constructor(args) {
    super(args.message, args)
    this.name = 'UnauthorizedError'
    this.code = args.code
    this.message = args.message
    this.status = args.status
  }
}

export { UnauthorizedError }
